import { Badge } from "@/components/ui/badge";

const STATUS_MAP = {
  pending_payment: { label: "Pago pendiente", cls: "bg-amber-100 text-amber-800 border-amber-200" },
  submitted: { label: "Pago por verificar", cls: "bg-blue-100 text-blue-800 border-blue-200" },
  payment_rejected: { label: "Pago rechazado", cls: "bg-red-100 text-red-700 border-red-200" },
  in_review: { label: "En revisión", cls: "bg-sky-100 text-sky-800 border-sky-200" },
  completed: { label: "Completada", cls: "bg-emerald-100 text-emerald-800 border-emerald-200" },
};

export function StatusBadge({ status }) {
  const s = STATUS_MAP[status] || { label: status, cls: "bg-stone-100 text-stone-700" };
  return (
    <Badge variant="outline" className={`${s.cls} rounded-full font-medium`} data-testid={`status-badge-${status}`}>
      {s.label}
    </Badge>
  );
}
